/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import './BrandCustom.scss';
import {
    Label,
    Input,
    Form,
    Card,
    Col,
    CardBody,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    ButtonDropdown,
    DropdownMenu,
    DropdownToggle,
    Button,
} from 'reactstrap';
import { Buttons, CancelButton, UpdateButton } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { updateStyleDocument } from '../../../helpers/tools_helper';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import IButton from '../../../components/Common/iComponents/iButton/IButton';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';

import Dropzone, { DropzoneOptions } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { updateImageClients } from '../../../store/actions';
import { Row } from 'reactstrap';

import classnames from 'classnames';
import Swal from 'sweetalert2';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import Widgets from '../../Dashboard/Widgets';
import Orders from '../../Dashboard/Orders';
import MarketOverview from '../../Dashboard/MarketOverview';
import MultiColor from '../../../components/Common/MultiColor/MultiColor';
import PreviousRequestCount from './previousRequestCount';

import FormBrandModalColors from './form-BrandModalColors';
import Slider from '@mui/material/Slider';

import RegistrySetRequest from '../../../pages/RegistrySetRequest/RegistrySetRequest';
import OauthGoogle from './OauthGoogle';
import OauthMicrosoft from './OauthMicrosoft';
import moment from 'moment';

const FormClientBrandCustom = ({ selectedRow, onUpdateClient }: any) => {
    const dispatch = useDispatch();
    const [def, setdef] = useState(15);

    const arrayUpdAdd = [
        'primaryColor',
        'secondaryColor',
        'sidebarBgColor',
        'headerBgColor',
        'primaryDarkColor',
        'secondaryDarkColor',
        'headerDarkBgColor',
    ];
    const columsPop = 2;
    const toggleField = 'enabled';
    const [rol, setRol] = useState(0);
    const [form, setForm] = useState({
        [toggleField]: false,
        name: '',
        email: '',
        company: '',
        description: '',
        logo: '',
        logoSmall: '',
        primaryColor: '',
        secondaryColor: '',
        primaryDarkColor: '',
        secondaryDarkColor: '',
        sidebarBgColor: '',
        headerBgColor: '',
        headerDarkBgColor: '',
        smtpEmail: '',
        smtpPassword: '',
        smtpHost: '',
        smtpPort: '',
        smtpsecure: false,
        smtpAccesstoken: '',
        clientGoogleId: '',
        clientGoogleSecret: '',
        refreshTokenGoogle: '',
        emailType: '',

        lineGraphicTitle: '',
        lineGraphicColor: '',
        donutGraphicTitle: '',
        donutGraphicColor: [],
        barGraphicTitle: '',
        barGraphicColor: [],
        formatDate: "",
        longDecimal: "",
        longInteger: "",
        timeZone: "",
        availableRequests: 0,
        countRequest: 0,
        restartDay: 1,
        activeRequest: false,
        progressRequest: 70,
        urlLinkBanner: "",
        urlImgBanner:"",
        nameUserGoogle: "",
        photoUserGoogle: "",
    });
    const [flag, setflag] = useState<any>(true);
    const [activeSendEmail, setActiveSendEmail] = useState<any>(false);

    type TabEmailType = {
        smtpEmail: string;
        smtpPassword: string;
        smtpHost: string;
        smtpPort: string;
        smtpsecure: boolean;
        smtpAccesstoken: string;
        clientGoogleId: string;
        clientGoogleSecret: string;
        refreshTokenGoogle: string;
    };
    type TabRequestType = {
        availableRequests: number;
        countRequest: number;
        restartDay: number;
        activeRequest: boolean;
    };

    //-----------------------------------------------------

    const ListEmail: Array<keyof TabEmailType> = ['smtpEmail', 'smtpPassword', 'smtpHost', 'smtpPort', 'smtpAccesstoken', 'smtpsecure'];
    const ListEmailGoogle: Array<keyof TabEmailType> = ['smtpEmail', 'clientGoogleId', 'clientGoogleSecret', 'refreshTokenGoogle'];
    const ListRequest: Array<keyof TabRequestType> = ['availableRequests', 'countRequest', 'restartDay', 'activeRequest'];

    const [finalNumber, setFinalNumber] = useState(0);

    interface Option {
        value: string;
        label: string;
    }

    interface DataType {
        nameKey: string;
        title: string;
        type: string;
        options?: Option[];
    }

    // Dashboards ahora viven en Holistics: la pestana queda oculta, sin borrar el codigo
    const SHOW_DASHBOARD_COLORS = false;
    const TIME_ZONES: Option[] = [
        { value: "", label: "Time zone: UTC (default)" },
        { value: "America/Bogota", label: "Bogota (UTC-5)" },
        { value: "America/New_York", label: "New York / Miami (ET)" },
        { value: "America/Chicago", label: "Chicago (CT)" },
        { value: "America/Denver", label: "Denver (MT)" },
        { value: "America/Los_Angeles", label: "Los Angeles (PT)" },
        { value: "America/Mexico_City", label: "Mexico City" },
        { value: "America/Guatemala", label: "Guatemala" },
        { value: "America/El_Salvador", label: "El Salvador" },
        { value: "America/Tegucigalpa", label: "Honduras" },
        { value: "America/Costa_Rica", label: "Costa Rica" },
        { value: "America/Panama", label: "Panama" },
        { value: "America/Santo_Domingo", label: "Santo Domingo" },
        { value: "America/Puerto_Rico", label: "Puerto Rico" },
        { value: "America/Curacao", label: "Curacao" },
        { value: "America/Caracas", label: "Caracas" },
        { value: "America/Lima", label: "Lima" },
        { value: "America/Guayaquil", label: "Ecuador" },
        { value: "America/Santiago", label: "Santiago" },
        { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires" },
        { value: "America/Sao_Paulo", label: "Sao Paulo" },
        { value: "Europe/Madrid", label: "Madrid" },
        { value: "UTC", label: "UTC" }
    ];

    const ListDataTypes: DataType[] = [
        { title: "Number of decimals", nameKey: "longDecimal", type: "text" },
        { title: "Required length", nameKey: "longInteger", type: "text" },
        {
            title: "Date format", nameKey: "formatDate", type: "select", options: [
                { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
                { value: "YYYY-MM-DD", label: "YYYY-MM-DD" },
                { value: "MM-DD-YYYY", label: "MM-DD-YYYY" },
            ]
        },
        { title: "Time zone", nameKey: "timeZone", type: "select", options: TIME_ZONES }
    ]

    interface DashboardColorsState {
        CardColorTitle: string;
        LineColor: string;
        DonutsColorTitle: string;
        colorsDonuts: { value: string; label: string }[];
        BartColorTitle: string;
        colorsBart: { value: string; label: string }[];
    }

    const initialState: DashboardColorsState = {
        CardColorTitle: '',
        LineColor: '',
        DonutsColorTitle: '',
        colorsDonuts: [],
        BartColorTitle: '',
        colorsBart: [],
    };

    const [DashboardColors, setDashboardColors] = useState(initialState);

    const DashboardColorsMap = [
        {
            title: 'Cards color',
            campos: {
                TituloCampo1: 'Title Text Color',
                isMulti1: false,
                TituloCampo2: 'Line Color',
                isMulti2: false,
                namePropTitle: 'CardColorTitle',
                namePropColors: 'LineColor',
            },
        },
        { grafica: 'Line' },
        {
            title: 'Donuts color',
            campos: {
                TituloCampo1: 'Title Text Color',
                isMulti1: false,
                TituloCampo2: 'Colors',
                isMulti2: true,
                namePropTitle: 'DonutsColorTitle',
                namePropColors: 'colorsDonuts',
            },
        },
        { grafica: 'Donuts' },
        {
            title: 'Bars color',
            campos: {
                TituloCampo1: 'Title Text Color',
                isMulti1: false,
                TituloCampo2: 'Colors',
                isMulti2: true,
                namePropTitle: 'BartColorTitle',
                namePropColors: 'colorsBart',
            },
        },
        { grafica: 'Bart' },
    ];

    const onChangeBooleanHandler = (e: any, n: any) => {
        if (n == "activeRequest") {
            setForm({
                ...form,
                [n]: e,
            });
        } else {
            setForm({
                ...form,
                smtpsecure: !form.smtpsecure,
            });
        }
    };

    const onChangeHandlerMultiColors = (color: any, Colors: any, isMulti: any) => {
        if (
            isMulti === false
        ) {
            setDashboardColors({
                ...DashboardColors,
                [Colors]: color,
            });
            return;
        }

        if (
            (DashboardColors[
                Colors as keyof DashboardColorsState
            ] as string | undefined) &&
            DashboardColors[
                Colors as keyof DashboardColorsState
            ].length < 10
        ) {
            const currentColors =
                DashboardColors[
                Colors as keyof DashboardColorsState
                ];
            const newColors: {
                value: any;
                label: any;
            }[] = Array.isArray(currentColors)
                    ? [
                        ...currentColors,
                        {
                            value: color,
                            label: color,
                        },
                    ]
                    : [
                        {
                            value: color,
                            label: color,
                        },
                    ];

            setDashboardColors({
                ...DashboardColors,
                [Colors]: newColors,
            });
        }
    };

    const LineExample: any = [
        {
            id: 1,
            title: 'Line Cards',
            price: '0',
            isDoller: true,
            postFix: ``,
            statusColor: `success`,
            series: ['0', '0', '2', '1', '3', '0'],
        },
    ];

    const inicialStateDonuts = {
        id: 3,
        key: 3,
        title: 'Example Donut',
        price: 1,
        isDoller: false,
        colors: ['#1c22ce'],
        labels: ['Example Donut'],
        options: {
            ColorTitle: DashboardColors.DonutsColorTitle || '#495057',
            chart: { type: 'donut' },
            colors: ['#1c22ce'],
            dataLabels: { enabled: false },
            labels: ['Example Donut'],
            legend: { show: false },
            responsive: [{}],
            states: { hover: {} },
            stroke: { width: 0 },
            tooltip: { enabled: true },
        },
        postFix: '',
        series: [1],
        statusColor: 'success',
    };

    const inicialStateBart = [
        {
            labels: ['Example Bar'],
            Profit: ['50'],
            Loss: ['0', '0'],
            colors: ['#1c22ce'],
            titleBar: 'Example Bar',
            ColorTitle: DashboardColors.BartColorTitle || '#495057',
        },
    ];

    const [DonutsExample, setDonutsExample] = useState(inicialStateDonuts);
    const [BarExample, setBarExample] = useState(inicialStateBart);

    const updateForm = (title: any, colors: any, titleprop: any, colorsprop: any) => {
        setForm({
            ...form,
            [title]: titleprop,
            [colors]: colorsprop,
        });
    };

    useEffect(() => {
        updateForm('lineGraphicTitle', 'lineGraphicColor', DashboardColors.CardColorTitle, DashboardColors.LineColor);
    }, [DashboardColors.CardColorTitle, DashboardColors.LineColor]);

    useEffect(() => {
        //-----------------------------------------------------
        updateForm('donutGraphicTitle', 'donutGraphicColor', DashboardColors.DonutsColorTitle, DashboardColors.colorsDonuts);
        if (DashboardColors.colorsDonuts.length != 0) {
            const newState: any = DashboardColors.colorsDonuts.map(({ label }) => label);
            setDonutsExample({
                id: 3,
                key: 3,
                title: 'Example Donuts',
                price: 1,
                isDoller: false,
                colors: newState.filter((a: any) => {
                    return a != undefined;
                }),
                labels: newState.filter((a: any) => {
                    return a != undefined;
                }),
                options: {
                    ColorTitle: DashboardColors.DonutsColorTitle || '#495057',
                    chart: { type: 'donut' },
                    colors: newState.filter((a: any) => {
                        return a != undefined;
                    }),
                    dataLabels: { enabled: false },
                    labels: newState.filter((a: any) => {
                        return a != undefined;
                    }),
                    legend: { show: false },
                    responsive: [{}],
                    states: { hover: {} },
                    stroke: { width: 0 },
                    tooltip: { enabled: true },
                },
                postFix: '',
                series: newState.map(() => 1),
                statusColor: 'success',
            });
        } else {
            setDonutsExample(inicialStateDonuts);
        }
    }, [DashboardColors.colorsDonuts, DashboardColors.DonutsColorTitle]);

    useEffect(() => {
        updateForm('barGraphicTitle', 'barGraphicColor', DashboardColors.BartColorTitle, DashboardColors.colorsBart);
        if (DashboardColors.colorsBart.length != 0) {
            const newState: any = DashboardColors.colorsBart.map(({ label }) => label);
            setBarExample([
                {
                    labels: newState.filter((a: any) => {
                        return a != undefined;
                    }),
                    Profit: newState.map(() => 50),
                    Loss: ['0', '0'],
                    colors: newState.filter((a: any) => {
                        return a != undefined;
                    }),
                    titleBar: 'Example Bar',
                    ColorTitle: DashboardColors.BartColorTitle || '#495057',
                },
            ]);
        } else {
            setBarExample(inicialStateBart);
        }
    }, [DashboardColors.colorsBart, DashboardColors.BartColorTitle]);

    const options: Object = {
        ColorTitle: DashboardColors.CardColorTitle || '#495057',
        chart: {
            height: 40,
            type: 'line',
            toolbar: { show: false },
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            colors: [DashboardColors.LineColor || '#0E113E'],
        },
        xaxis: {
            labels: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        tooltip: {
            fixed: {
                enabled: false,
            },
            x: {
                show: false,
            },
            y: {
                title: {
                    formatter: function (seriesName: any) {
                        return '';
                    },
                },
            },
            marker: {
                show: false,
            },
        },
    };

    useEffect(() => {
        const authUser: any = localStorage.getItem('authUser');
        const UserLocal = JSON.parse(authUser);
        setRol(UserLocal.ROL_ID)
      }, []);

    useEffect(() => {
        if (selectedRow) {
            setForm(selectedRow);
            setselectedFiles({
                logo: {
                    url: itemVals('logo', selectedRow),
                    blob: selectedFiles['logo']?.blob ?? '',
                },
                logoSmall: {
                    url: itemVals('logoSmall', selectedRow),
                    blob: selectedFiles['logoSmall']?.blob ?? '',
                },
                urlHome: {
                    url: itemVals('urlHome', selectedRow),
                    blob: selectedFiles['urlHome']?.blob ?? '',
                },
                urlLogin: {
                    url: itemVals('urlLogin', selectedRow),
                    blob: selectedFiles['urlLogin']?.blob ?? '',
                },
                urlFavicon: {
                    url: itemVals('urlFavicon', selectedRow),
                    blob: selectedFiles['urlFavicon']?.blob ?? '',
                },
                urlLoading: {
                    url: itemVals('urlLoading', selectedRow),
                    blob: selectedFiles['urlLoading']?.blob ?? '',
                },
                urlImgBanner: {
                    url: itemVals('urlImgBanner', selectedRow) || "https://icones.pro/wp-content/uploads/2021/06/symbole-d-image-noir.png",
                    blob: selectedFiles['urlImgBanner']?.blob ?? '',
                },
            });
            setDashboardColors({
                CardColorTitle: selectedRow.lineGraphicTitle || '',
                LineColor: selectedRow.lineGraphicColor || '',
                DonutsColorTitle: selectedRow.donutGraphicTitle || '',
                colorsDonuts: selectedRow.donutGraphicColor || [],
                BartColorTitle: selectedRow.barGraphicTitle || '',
                colorsBart: selectedRow.barGraphicColor || [],
            });

            if (selectedRow.clientGoogleId || selectedRow.clientGoogleSecret || selectedRow.refreshTokenGoogle) {
                setActiveSendEmail(true)
            }
        }
    }, [selectedRow]);

    const itemVals = (val: any, updateVal: any) => {
        for (const property in updateVal) {
            if (property === val) {
                return updateVal[property];
            }
        }
    };
    const onChangeHandler = (e: any, n: any) => {
        let value = e.target.value
        if (n === 'Email' || n === 'Password' || n === 'Host' || n === 'Port' || n === 'Accesstoken' || n === 'secure') {
            n = `smtp${n}`;
        }
        if (n === "availableRequests") {
            if (value < 0 || value == "e") value = 0;
        }
        if (n === "restartDay") {
            if (value <= 0 || value == "e") value = 1;
            if (value >= 31) value = 31;
        }
        setForm({
            ...form,
            [n]: value,
        });
    };

    // Al cambiar de servicio de correo se limpia la conexion anterior: un token de Google no sirve como Microsoft ni al reves.
    const onChangeEmailType = (nuevo: string) => {
        if (nuevo === form.emailType) return;
        setForm({
            ...form,
            emailType: nuevo,
            refreshTokenGoogle: '',
            smtpEmail: '',
            nameUserGoogle: '',
            photoUserGoogle: '',
        });
    };

    const updateStyle = (form: any) => {
        let theme;
        const brand = localStorage.getItem('brand');
        let newBrand;
        if (brand) {
            theme = JSON.parse(brand).theme;
            newBrand = JSON.parse(brand);
            newBrand.theme.primaryColor = form.primaryColor;
            newBrand.theme.secondaryColor = form.secondaryColor;
            newBrand.theme.primaryDarkColor = form.primaryDarkColor;
            newBrand.theme.secondaryDarkColor = form.secondaryDarkColor;
            newBrand.theme.sidebarBgColor = form.sidebarBgColor;
            newBrand.theme.headerBgColor = form.headerBgColor;
            newBrand.theme.headerDarkBgColor = form.headerDarkBgColor;

            newBrand.theme.modalHeaderBackground = form.modalHeaderBackground;
            newBrand.theme.modalHeaderTitle = form.modalHeaderTitle;
            newBrand.theme.modalHeaderText = form.modalHeaderText;
            newBrand.theme.isMilestoneBackground = form.isMilestoneBackground;
            newBrand.theme.isMilestoneCircle = form.isMilestoneCircle;
            newBrand.theme.isMilestoneText = form.isMilestoneText;
            newBrand.theme.modalBodyBackground = form.modalBodyBackground;
            newBrand.theme.modalBodyTitle = form.modalBodyTitle;
            newBrand.theme.modalBodyText = form.modalBodyText;
            newBrand.theme.modalTotalBackground = form.modalTotalBackground;
            newBrand.theme.modalTotalText = form.modalTotalText;

            localStorage.setItem('brand', JSON.stringify(newBrand));
        }
        updateStyleDocument();
    };
    const updateFinalClient = (form: any) => {
        updateStyle(form);
        onUpdateClient(form);
    };
    const onCancelPreview = () => {
        let theme;
        const brand = localStorage.getItem('brand');
        let newBrand;
        if (brand) {
            theme = JSON.parse(brand).theme;
            newBrand = JSON.parse(brand);
            newBrand.theme.primaryColor = selectedRow.primaryColor;
            newBrand.theme.secondaryColor = selectedRow.secondaryColor;
            newBrand.theme.primaryDarkColor = selectedRow.primaryDarkColor;
            newBrand.theme.secondaryDarkColor = selectedRow.secondaryDarkColor;
            newBrand.theme.sidebarBgColor = selectedRow.sidebarBgColor;
            newBrand.theme.headerBgColor = selectedRow.headerBgColor;
            newBrand.theme.headerDarkBgColor = selectedRow.headerDarkBgColor;

            newBrand.theme.modalHeaderBackground = selectedRow.modalHeaderBackground;
            newBrand.theme.modalHeaderTitle = selectedRow.modalHeaderTitle;
            newBrand.theme.modalHeaderText = selectedRow.modalHeaderText;
            newBrand.theme.isMilestoneBackground = selectedRow.isMilestoneBackground;
            newBrand.theme.isMilestoneCircle = selectedRow.isMilestoneCircle;
            newBrand.theme.isMilestoneText = selectedRow.isMilestoneText;
            newBrand.theme.modalBodyBackground = selectedRow.modalBodyBackground;
            newBrand.theme.modalBodyTitle = selectedRow.modalBodyTitle;
            newBrand.theme.modalBodyText = selectedRow.modalBodyText;
            newBrand.theme.modalTotalBackground = selectedRow.modalTotalBackground;
            newBrand.theme.modalTotalText = selectedRow.modalTotalText;
            localStorage.setItem('brand', JSON.stringify(newBrand));
        }
        const tmpForm = {
            primaryColor: selectedRow.primaryColor,
            secondaryColor: selectedRow.secondaryColor,
            primaryDarkColor: selectedRow.primaryDarkColor,
            secondaryDarkColor: selectedRow.secondaryDarkColor,
            sidebarBgColor: selectedRow.sidebarBgColor,
            headerBgColor: selectedRow.headerBgColor,
            headerDarkBgColor: selectedRow.headerDarkBgColor,

            modalHeaderBackground: selectedRow.modalHeaderBackground,
            modalHeaderTitle: selectedRow.modalHeaderTitle,
            modalHeaderText: selectedRow.modalHeaderText,
            isMilestoneBackground: selectedRow.isMilestoneBackground,
            isMilestoneCircle: selectedRow.isMilestoneCircle,
            isMilestoneText: selectedRow.isMilestoneText,
            modalBodyBackground: selectedRow.modalBodyBackground,
            modalBodyTitle: selectedRow.modalBodyTitle,
            modalBodyText: selectedRow.modalBodyText,
            modalTotalBackground: selectedRow.modalTotalBackground,
            modalTotalText: selectedRow.modalTotalText
        };
        setForm({ ...form, ...tmpForm });
        updateStyleDocument();
    };

    const renderButtons = () => (
        <Buttons>
            <>
                <CancelButton className="button" onClick={() => onCancelPreview()} data-bs-toggle="tooltip">
                    <i className="bx bx-power-off" style={{ fontSize: '2.5em' }} data-bs-toggle="tooltip"></i>
                </CancelButton>
                <UpdateButton className="button" disabled={flag} onClick={() => updateFinalClient(form)}>
                    <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                </UpdateButton>
                <UpdateButton className="button" disabled={flag} onClick={() => updateStyle(form)}>
                    <i className="dripicons-preview" style={{ fontSize: '2.5em' }}></i>
                </UpdateButton>
            </>
        </Buttons>
    );

    useEffect(() => {
        const {
            logo,
            logoSmall,
            primaryColor,
            secondaryColor,
            primaryDarkColor,
            secondaryDarkColor,
            sidebarBgColor,
            headerBgColor,
            headerDarkBgColor,
        } = form;
        if (
            primaryColor != '' &&
            secondaryColor != '' &&
            primaryDarkColor != '' &&
            secondaryDarkColor != '' &&
            sidebarBgColor != '' &&
            headerBgColor != '' &&
            headerDarkBgColor != ''
        ) {
            setflag(false);
        } else {
            setflag(true);
        }
    }, [form]);

    /* UPLOAD IMAGES */

    const colors = {
        primaryColor: false,
        secondaryColor: false,
        sidebarBgColor: false,
        headerBgColor: false,
        primaryDarkColor: false,
        secondaryDarkColor: false,
        headerDarkBgColor: false,
    };

    const [selectedFiles, setselectedFiles] = useState<any>({
        logo: { url: '', blob: '' },
        logoSmall: { url: '', blob: '' },
        urlHome: { url: '', blob: '' },
        urlLogin: { url: '', blob: '' },
        urlFavicon: { url: '', blob: '' },
        urlLoading: { url: '', blob: '' },
        urlImgBanner: {url: '',blob: ''}

    });

    const [verticalActiveTab, setverticalActiveTab] = useState('BrandColors');
    const [dropdownActive, setDropDownActive] = useState<any>(colors);
    const [popUpState, setpopUpState] = useState(false);
    const [popUpStateOauth, setpopUpStateOauth] = useState(false);

    const isDarkColor = (color: any) => {
        if (color === 'null') color = '#000000';
        const r = parseInt(color?.substring(1, 3), 16);
        const g = parseInt(color?.substring(3, 5), 16);
        const b = parseInt(color?.substring(5, 7), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance < 0.5;
    };

    const toggleVertical = (tab: any) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    const dropzonProps = ({ nameVal = '' }: any) => {
        const object: DropzoneOptions = {
            accept: { 'image/jpeg': ['.png', '.gif', '.jpeg', '.jpg'] },
            multiple: false,
            noDrag: true,
            onDrop: (acceptedFiles: any) => {
                handleAcceptedFiles(acceptedFiles, nameVal);
            },
        };
        return object;
    };

    function handleAcceptedFiles(files: any, nameVal: any) {
        Swal.fire({
            icon: 'question',
            title: 'Do you want to save ?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                let urk = '';
                files.map((file: any) => (urk = URL.createObjectURL(file)));
                const newObject = { ...selectedFiles };
                newObject[nameVal].blob = urk;
                newObject[nameVal].url = '';
                dispatch(
                    updateImageClients({
                        file: files[0],
                        networkId: form.company,
                        nameField: nameVal,
                    }),
                );
                setselectedFiles(newObject);
                Swal.fire('Saved!', '', 'success');
            }
        });
    }

    const TabPaneLogo = (name: string, dimensions?: any,imgHeight?:any,secondButton?:any) => {
        return (
            <div className="pt-4 row d-flex align-items-center justify-content-center">
                <div className="col-4 d-flex align-items-center justify-content-center">
                    {selectedFiles[name]?.url?.trim() ? (
                        <Dropzone {...dropzonProps({ nameVal: name })}>
                            {({ getRootProps, getInputProps }) => (
                                <div className="pb-1" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="cursor-pointer d-flex justify-content-center">
                                        <img
                                            style={{ maxWidth: 251 }}
                                            height={imgHeight ? imgHeight: 150}
                                            alt={name}
                                            src={selectedFiles[name]?.url ?  selectedFiles[name]?.url + `?timestamp=${Date.now()}` : selectedFiles[name]?.blob}
                                        />
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    ) : null}
                </div>
                <div className="col-12 d-flex align-items-center justify-content-center">
                    {dimensions ? (<div>
                        <p className='mb-0 mt-2'>Recommended size</p>
                        {dimensions.map((dimension: any, index: number) => {
                            return (
                                <p className='m-0' key={`${dimension.x}-${index}`}>-{dimension.x} x {dimension.y}</p>
                            )
                        })}
                    </div>) : null}
                </div>

                <div className="col-12">
                    <Form>
                        <Dropzone {...dropzonProps({ nameVal: name })}>
                            {({ getRootProps, getInputProps }) => (
                                <div className='d-flex justify-content-center align-content-center dz-message needsclick mt-2'>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />

                                        <Button
                                            className="btn-base"
                                            onClick={(e: any) => e.preventDefault()}
                                        >
                                            <div className='d-flex align-items-center'>

                                                {
                                                    name
                                                        .replace("urlLoading", "Loading Logo")
                                                        .replace("urlLogin", "Login")
                                                        .replace("urlHome", "Home")
                                                        .replace("urlFavicon", "Favicon")
                                                        .replace("logoSmall", "Logo Small")
                                                        .replace("logo", "Logo")
                                                        .replace("urlImgBanner", "Img Banner")
                                                }
                                                <i className="ps-2 display-7 bx bx-upload bx-tada-hover" />
                                            </div>
                                        </Button>
                                    </div>
                                    {secondButton && (
                                        <Button
                                            className="btn-base"
                                            onClick={() => secondButton.functionButton()}
                                        >
                                            <div className='d-flex align-items-center'>
                                                {secondButton.label}
                                                <i className="ps-2 display-7 bx bx-upload bx-tada-hover" />
                                            </div>
                                        </Button>
                                        )}
                                </div>
                            )}
                        </Dropzone>
                    </Form>
                </div>
            </div>
        );
    };

    const InfoColor = (name: any) => {
        const infoColors: any = {
            primaryColor:
                'Change the titles in the menu. Change the selected titles. Change the main buttons. Change the table headers. Change the alert headers',
            secondaryColor: 'Change the subtitle fonts',
            sidebarBgColor: 'Change the menu. Change the icons',
            headerBgColor: 'Change the top part of the page',
            primaryDarkColor: 'Change the loading icon',
            secondaryDarkColor: 'Change the hover effect on a button. Change the permissions menu icon',
            headerDarkBgColor: '',
        };
        return (
            <>
                {infoColors[name]?.split('. ').map((item: any) => {
                    return <div className="">{item ? '- ' + item + '.' : null}</div>;
                })}
            </>
        );
    };

    const clearDataAdvertising = ()=>{
        onUpdateClient({
            ...form,
            urlLinkBanner: "",
            urlImgBanner:""
        })
    }


    const renderDataTypes = () => {
        return (
            <div className='Container-dataTypes'>
                {ListDataTypes.map((file: DataType, index) => {

                    if (file.type !== 'select') {
                        return (
                            <IInput
                                key={`${file.title}-${index}`}
                                title={file.title}
                                nameKey={file.nameKey}
                                // valid={form[file.nameKey] != '' ? true : false}
                                value={form[file.nameKey as keyof typeof form]}
                                type={file.type}
                                onInputHandler={onChangeHandler}
                            />
                        );
                    } else {
                        return (
                            <Input
                                key={`${file.title}-${index}`}
                                title={file.title}
                                value={form[file.nameKey as keyof typeof form] as string}
                                type={file.type}
                                onChange={(e) => { onChangeHandler(e, file.nameKey) }}
                            >
                                {file.options && file.options.map((option: any) => (
                                    <option key={`${option.value}-${option.label}`} value={option.value}>{option.label}</option>
                                ))}

                            </Input>
                        )

                    }

                })}
            </div>
        )
    }
    return (
        <>
            <div>
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <Nav tabs className="navStyle">
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand ': true,
                                            active: verticalActiveTab === 'Brand identity',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Brand identity');
                                        }}
                                    >
                                        Brand identity
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'BrandColors',
                                        })}
                                        onClick={() => {
                                            toggleVertical('BrandColors');
                                        }}
                                    >
                                        Brand Colors
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'Email',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Email');
                                        }}
                                    >
                                        Email Config
                                    </NavLink>
                                </NavItem>
                                {SHOW_DASHBOARD_COLORS && (<NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'Dashboard Colors',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Dashboard Colors');
                                        }}
                                    >
                                        Dashboard Colors
                                    </NavLink>
                                </NavItem>)}
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'Data type',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Data type');
                                        }}
                                    >
                                        Data type
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'Requests Info',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Requests Info');
                                        }}
                                    >
                                        Requests Info
                                    </NavLink>
                                </NavItem>
                                {rol == 19 ? (
                                    <NavItem>
                                    <NavLink
                                        className={classnames({
                                            'mb-2 cursor-pointer colorTextConfigBrand': true,
                                            active: verticalActiveTab === 'Advertising',
                                        })}
                                        onClick={() => {
                                            toggleVertical('Advertising');
                                        }}
                                    >
                                        Advertising
                                    </NavLink>
                                </NavItem>
                                ):null}
                            </Nav>

                            <TabContent activeTab={verticalActiveTab} className="text-muted mt-4 mt-md-0">
                                <TabPane tabId="Brand identity">
                                    <div className='row'>
                                        <div className='col-3'>
                                            {TabPaneLogo('logo')}
                                        </div>
                                        <div className='col-3'>
                                            {TabPaneLogo('logoSmall')}
                                        </div>
                                        <div className='col-3'>
                                            {TabPaneLogo('urlFavicon')}
                                        </div>
                                        <div className='col-3'>
                                            {TabPaneLogo('urlLoading')}
                                        </div>
                                        <div className='col-3'>
                                            {TabPaneLogo('urlHome', [{ x: "1600", y: "900" }, { x: "1366", y: "768" }, { x: "1280", y: "720" }])}
                                        </div>
                                        <div className='col-3'>
                                            {TabPaneLogo('urlLogin', [{ x: "1600", y: "1200" }, { x: "1400", y: "1050" }, { x: "1280", y: "960" }])}
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tabId="BrandColors">
                                    <Card className='mt-1'>
                                        <CardBody>
                                            <div className="row">
                                                <h5 className='text-center colorTextConfigBrand'>
                                                    General Colors
                                                </h5>
                                                {arrayUpdAdd?.map((val: any) => {
                                                    const value = selectedRow ? itemVals(val, form) : null;
                                                    const fontDarker = isDarkColor(value);
                                                    return (
                                                        <>
                                                            <div className="col-3 pt-4 row text-center container-colors">
                                                                <div className="btn-group secondary">
                                                                    <ButtonDropdown
                                                                        toggle={() =>
                                                                            setDropDownActive({
                                                                                ...dropdownActive,
                                                                                [val]: !dropdownActive[val],
                                                                            })
                                                                        }
                                                                        className="ButtonDropdownHover"
                                                                        isOpen={dropdownActive[val]}
                                                                        onMouseEnter={() =>
                                                                            setDropDownActive({
                                                                                ...dropdownActive,
                                                                                [val]: true,
                                                                            })
                                                                        }
                                                                        onMouseLeave={() =>
                                                                            setDropDownActive({
                                                                                ...dropdownActive,
                                                                                [val]: false,
                                                                            })
                                                                        }
                                                                    >
                                                                        <Label className="inputTextConfigBrand">
                                                                            <div
                                                                                className="position-absolute labelConfigBrand cursor-pointer text-capitalize"
                                                                                style={{
                                                                                    color: fontDarker ? 'white' : 'black',
                                                                                }}
                                                                            >
                                                                                {val}
                                                                            </div>
                                                                            <Input
                                                                                type="color"
                                                                                className="cursor-pointer inputConfigBrand"
                                                                                placeholder={val}
                                                                                plaintext={true}
                                                                                value={value}
                                                                                onChange={(e: any) => {
                                                                                    const n = val;
                                                                                    setForm({
                                                                                        ...form,
                                                                                        [n]: e.target.value,
                                                                                    });
                                                                                    setDropDownActive({
                                                                                        ...dropdownActive,
                                                                                        [val]: false,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </Label>

                                                                        <DropdownToggle
                                                                            className={classnames({
                                                                                DropdownToggle: true,
                                                                                DropdownToggleDark: !fontDarker,
                                                                            })}
                                                                            outline
                                                                            style={{ backgroundColor: value }}
                                                                            caret
                                                                        >
                                                                            <div>
                                                                                <i
                                                                                    className={classnames({
                                                                                        'bx bx-info-circle pt-1': true,
                                                                                        'bx-tada': dropdownActive[val],
                                                                                    })}
                                                                                    style={{
                                                                                        color: fontDarker ? 'white' : 'black',
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </DropdownToggle>
                                                                        <DropdownMenu flip={true} className="position-absolute dropdownConfigBrand">
                                                                            {InfoColor(val)}
                                                                        </DropdownMenu>
                                                                    </ButtonDropdown>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <FormBrandModalColors selectedRow={selectedRow} onChangeColor={onChangeHandler} />
                                </TabPane>
                                <TabPane tabId="Email">
                                    <div className='row pt-3 justify-content-center align-items-center'>
                                        <div className='col-5 mb-5' style={{ zIndex: 99 }}>
                                            <Select
                                                defaultValue={{ label: form.emailType ?? 'Choose an email service' }}
                                                value={{ label: form.emailType == "" ? 'Choose an email service' : form.emailType }}
                                                onChange={(e: any) => onChangeEmailType(e.label)}
                                                options={[
                                                    { label: "Google", value: "Google" },
                                                    { label: "Microsoft", value: "Microsoft" },
                                                    { label: "Outlook", value: "Outlook" },
                                                ]}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                        {

                                            form.emailType === 'Google' ?
                                                <OauthGoogle onUpdateClient={onUpdateClient} form={form} onChangeHandler={onChangeHandler} setForm={setForm} />
                                                : <></>

                                        }
                                        {
                                            form.emailType === 'Microsoft' ?
                                                <OauthMicrosoft onUpdateClient={onUpdateClient} form={form} setForm={setForm} />
                                                : <></>
                                        }
                                        {
                                            form.emailType === 'Outlook' ?
                                                <div className="Container-TabEmail">
                                                    {ListEmail.map((i: keyof TabEmailType) => {
                                                        if (i !== 'smtpsecure') {
                                                            return (
                                                                <IInput
                                                                    title={i.replace('smtp', '')}
                                                                    valid={form[i] != '' ? true : false}
                                                                    value={form[i]}
                                                                    type={i === 'smtpEmail' || i === 'smtpPassword' ? i.replace('smtp', '') : 'text'}
                                                                    onInputHandler={onChangeHandler}
                                                                />
                                                            );
                                                        } else {
                                                            return (
                                                                <div className="Container-Div-Switch">
                                                                    <div className="ContainerSwitch">
                                                                        <Label>
                                                                            <p>Secure: </p>
                                                                            <ISwitch
                                                                                title={'smtpsecure'}
                                                                                checked={Boolean(form.smtpsecure)}
                                                                                onChangeBooleanHandler={onChangeBooleanHandler}
                                                                            />
                                                                        </Label>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                </div>
                                                :
                                                <></>
                                        }

                                    </div>


                                    {form.emailType === 'Outlook' ?
                                        <div className="ButtonUpdateTabEmail">
                                            {
                                                activeSendEmail ?
                                                    <IButton
                                                        className="btn-base m-2"
                                                        label={'Send a Test Email'}
                                                        btnIcon="bx bx-send"
                                                        actionOnClick={() => setpopUpStateOauth(true)}
                                                    ></IButton>
                                                    :
                                                    <></>
                                            }
                                            <UpdateButton
                                                className="button"
                                                onClick={() => {
                                                    if (form.emailType === 'Outlook') onUpdateClient(form);
                                                    setActiveSendEmail(true)
                                                }}
                                            >
                                                <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                                            </UpdateButton>
                                        </div>
                                        :
                                        <></>
                                    }
                                </TabPane>
                                <TabPane tabId="Dashboard Colors">
                                    <div className="ConteineDashboardColorsr">
                                        {DashboardColorsMap.map((item: any) => {
                                            const title: string = item.campos && item.campos.namePropTitle ? item.campos.namePropTitle : null;
                                            const Colors: string = item.campos && item.campos.namePropColors ? item.campos.namePropColors : null;
                                            if (item.title) {
                                                return (
                                                    <div className="CardsColorInput">
                                                        <h4 className="titleDashboardColors">{item.title}</h4>
                                                        <div className="ConteinerInputsColor">
                                                            <MultiColor TextLabel={item.campos.TituloCampo1} updateColors={onChangeHandlerMultiColors} name={title} isMulti={item.campos.isMulti1} />
                                                            <MultiColor TextLabel={item.campos.TituloCampo2} updateColors={onChangeHandlerMultiColors} name={Colors} isMulti={item.campos.isMulti2} />
                                                        </div>
                                                        {item.campos &&
                                                            item.campos.isMulti2 &&
                                                            (DashboardColors[Colors as keyof DashboardColorsState] as string | undefined) &&
                                                            DashboardColors[Colors as keyof DashboardColorsState].length > 0 ? (
                                                            <Select
                                                                value={DashboardColors[Colors as keyof DashboardColorsState] as string | undefined}
                                                                isMulti={true}
                                                                isSearchable={false}
                                                                options={''}
                                                                onChange={(e: any) => {
                                                                    setDashboardColors({
                                                                        ...DashboardColors,
                                                                        [Colors]: e,
                                                                    });
                                                                }}
                                                                classNamePrefix="select2-selection"
                                                            />
                                                        ) : null}
                                                        <div></div>
                                                    </div>
                                                );
                                            } else {
                                                switch (item.grafica) {
                                                    case 'Line':
                                                        return (
                                                            <div>
                                                                <Row className="LineGrafica">
                                                                    <Widgets options={options} items={LineExample} />
                                                                </Row>
                                                            </div>
                                                        );
                                                    case 'Donuts':
                                                        return (
                                                            <div>
                                                                <Row className="DonutsGrafica">
                                                                    <Col xl={6} md={6} key={1}>
                                                                        <Orders item={DonutsExample} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    case 'Bart':
                                                        return (
                                                            <div>
                                                                <Row className="BartGrafica">
                                                                    <MarketOverview items={BarExample} />
                                                                </Row>
                                                            </div>
                                                        );
                                                }
                                            }
                                        })}
                                    </div>
                                    <div className="ButtonUpdateTabEmail">
                                        <UpdateButton
                                            className="button"
                                            disabled={false}
                                            onClick={() => {
                                                onUpdateClient(form);
                                            }}
                                        >
                                            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                                        </UpdateButton>
                                    </div>
                                </TabPane>
                                <TabPane tabId="Data type">{
                                    <div>

                                        {renderDataTypes()}

                                        <div className="ButtonUpdateTabEmail">
                                            <UpdateButton
                                                className="button"
                                                disabled={false}
                                                onClick={() => {
                                                    onUpdateClient(form);
                                                }}
                                            >
                                                <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                                            </UpdateButton>
                                        </div>
                                    </div>

                                }</TabPane>
                                <TabPane tabId="Requests Info">
                                    <div className='row justify-content-start align-items-center mt-3'>
                                        <div className="row col-6">
                                            {ListRequest.map((i: keyof TabRequestType) => {
                                                if (i !== 'activeRequest') {
                                                    return (
                                                        <div className='col-3'>
                                                            <IInput
                                                                title={i}
                                                                name={i
                                                                    .replace("availableRequests", "Available Requests")
                                                                    .replace("countRequest", "Requests Count")
                                                                    .replace("restartDay", "Restart Day")
                                                                }
                                                                useValue={true}
                                                                value={form[i]}
                                                                readonly={i === "countRequest"}
                                                                type={'number'}
                                                                onInputHandler={onChangeHandler}
                                                            />
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="col-3">
                                                            <div className="ContainerSwitch">
                                                                <Label>
                                                                    <div>Continue Requests</div>
                                                                    <div className='ms-4'>
                                                                        <ISwitch
                                                                            title={i}
                                                                            checked={form[i]}
                                                                            onChangeBooleanHandler={onChangeBooleanHandler}
                                                                        />
                                                                    </div>
                                                                </Label>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })}
                                            <div className='justify-content-center align-self-center d-flex mt-2 '>
                                                <div className='badge bg-danger fw-bold fs-4 text-wrap'
                                                    style={{ width: "25rem" }}>
                                                    Next restart is : <strong className='fs-5'> {Math.min(form.restartDay, moment().month(selectedRow.restartMonth == 0 ? 0 :  selectedRow.restartMonth - 1).endOf('month').date()) + "/" + moment().month(selectedRow.restartMonth == 0 ? 0 :  selectedRow.restartMonth - 1).format('MMMM') + "/" + (selectedRow.restartMonth === 1 ? moment().add(1, 'year').year() : moment().year())}</strong>
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <div className="ContainerSwitch">
                                                    <Label className='justify-content-center align-items-center d-flex'>
                                                        <div className='text-center mb-2'>Request Notification (%)</div>
                                                    </Label>
                                                    <Slider
                                                        className='ColorSlider mt-4'
                                                        aria-label="Request Notification"
                                                        defaultValue={form.progressRequest}
                                                        value={form.progressRequest}
                                                        onChange={(e) => onChangeHandler(e, "progressRequest")}
                                                        valueLabelDisplay="on"
                                                        step={10}
                                                        marks
                                                        min={10}
                                                        max={100}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-4 ps-3 pe-3'>
                                            <PreviousRequestCount />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <IButton
                                            className="btn-base"
                                            label={'Set Transaction Activity'}
                                            btnIcon="bx bx-search"
                                            actionOnClick={() => setpopUpState(true)}
                                        ></IButton>
                                    </div>
                                    <div className="ButtonUpdateTabEmail">
                                        <UpdateButton
                                            className="button"
                                            disabled={false}
                                            onClick={() => {
                                                onUpdateClient(form);
                                            }}
                                        >
                                            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                                        </UpdateButton>
                                    </div>

                                    <IPopUp
                                        stateAdd={popUpState}
                                        switchStateAdd={setpopUpState}
                                        modalTitleAdd={"Set Transaction Activity"}
                                        modaleTitleUpdate={'Sales Orders'}
                                        icon="search"
                                        colorHeaderPop={'#101340'}
                                        width='90%'
                                        height='90%'
                                    >
                                        <RegistrySetRequest />
                                    </IPopUp>
                                </TabPane>
                                <TabPane tabId="Advertising">
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <div className='col-3'>
                                            {TabPaneLogo('urlImgBanner',null,"auto",{functionButton: clearDataAdvertising ,label:"Clear"})}
                                        </div>
                                        <div className='row w-100 d-flex align-items-center justify-content-end'>
                                            <IInput
                                            title={"Url Link"}
                                            nameKey={"urlLinkBanner"}
                                            value={form.urlLinkBanner}
                                            type='text'
                                            onInputHandler={onChangeHandler}
                                        />

                                            <UpdateButton
                                                className="button m-3"
                                                disabled={false}
                                                onClick={() => {
                                                    onUpdateClient(form);
                                                }}
                                            >
                                                <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
                                            </UpdateButton>
                                        </div>
                                    </div>
                                            
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
                {verticalActiveTab === 'BrandColors' ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginRight: '1%',
                        }}
                    >
                        {renderButtons()}
                    </div>
                ) : null}
            </div >
        </>
    );
};

FormClientBrandCustom.propTypes = {
    selectedRow: PropTypes.object,
    onUpdateClient: PropTypes.func,
    onCancel: PropTypes.func,
};

export default FormClientBrandCustom;
